import { h, Component } from 'preact';
import styles from './date_picker_field_style';
import classNames from 'classnames';

import Pikaday from 'pikaday';

import '../../../../node_modules/pikaday/css/pikaday';

export default class DatePickerField extends Component {
  updateValue = (e) => {
    this.props.updateValue(e.target.value);
  } 
  componentDidMount() {
    new Pikaday({ field: this.base })
  }
  render({field, response, isValid},{}) {
		var classes = classNames({
      'form-control': true,
      'is-invalid': !isValid
    });
    let selectedDate = null;

		return (
      <input id={field.mapping} name={field.mapping} placeholder={field.label} class="form-control" onBlur={this.updateValue} />
		);
	}
}



// WEBPACK FOOTER //
// ./field_types/date_picker_field.js